import api from "./api";

export const paymentService = {
  listPayments: (params = {}) => api.get("/payments", { params }),
};
